var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTether({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.3971 24.8381C36.726 35.5525 25.8741 42.0731 15.1584 39.4012C4.44722 36.7301 -2.07335 25.8775 0.598971 15.1639C3.26894 4.44838 14.1209 -2.07268 24.8332 0.598468C35.5481 3.26961 42.0683 14.1234 39.3968 24.8383L39.397 24.8381H39.3971Z",
    fill: "#50AF95"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5309 22.2668C22.3894 22.2774 21.6588 22.321 20.0289 22.321C18.7326 22.321 17.8122 22.2821 17.4893 22.2668C12.4796 22.0464 8.74024 21.1743 8.74024 20.1302C8.74024 19.086 12.4796 18.2151 17.4893 17.9912V21.3982C17.8169 21.4218 18.755 21.4772 20.0513 21.4772C21.6069 21.4772 22.3859 21.4124 22.5261 21.3994V17.9936C27.5253 18.2163 31.2564 19.0884 31.2564 20.1302C31.2564 21.172 27.5265 22.044 22.5261 22.2656L22.5309 22.2668ZM22.5309 17.6412V14.5925H29.5075V9.94336H10.5127V14.5925H17.4881V17.64C11.8184 17.9005 7.55469 19.0236 7.55469 20.3694C7.55469 21.7152 11.8184 22.8372 17.4881 23.0988V32.8684H22.5297V23.0952C28.1864 22.8348 32.4431 21.7129 32.4431 20.3682C32.4431 19.0236 28.1899 17.9017 22.5297 17.64L22.5309 17.6412Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTether);
export default __webpack_public_path__ + "static/media/tether.59ba94d23fb5e773f78374cab07fcdf3.svg";
export { ForwardRef as ReactComponent };